import React from "react"

import { Button, Dialog, DialogActions, DialogContent } from "@mui/material"
import { COLORS } from "../../../../../utils"

const SectionOutputModal = ({ open, onClose, onValidate, title, disabled, children, btnCloseLabel = "Annuler", ...otherDialogProps }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiPaper-rounded": {
          maxWidth: 636,
        },
      }}
      {...otherDialogProps}
    >
      <DialogContent sx={{ padding: "32px 32px 16px 32px", fontWeight: 400 }}>
        <div style={{ display: "flex", alignItems: "center", color: COLORS.BLACK_500, gap: 4, marginBottom: 32 }}>
          {title}
        </div>
        <div className="dialog-container" style={{ display: "flex", flexDirection: "row", gap: 20, fontSize: 14 }}>
          {children}
        </div>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between", padding: "16px 32px 32px 32px" }}>
        <Button color="primary" onClick={onClose} sx={{ paddingLeft: 0 }}>
          {btnCloseLabel}
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={disabled}
          sx={{ "&.Mui-disabled": { color: COLORS.BLACK_500 } }}
          onClick={onValidate}
        >Valider</Button>
      </DialogActions>
    </Dialog>
  )
}

export default SectionOutputModal